module.exports = __webpack_public_path__ + "img/nexerion_blau.32baeb96.svg";